export default [{
	"widget" : {
		"type" : "shape",
		"data" : {
			"scorecards": {
				"126": {
					"id":126,
					"label":"Performance Bubble",
					"description":"",
					"type":"root",
					"useSourceNotes":false,
					"organizationId":100,
					"scores":{}
				}
			},
			"organizations": {
				"100": {
					"id":100,
					"label":"asdf",
					"view":true,
					"domainType":"organization"
				}
			}
		},
		"wob" : {
			"id" : 15001,
			"height" : 90,
			"width" : 150,
			"left" : 0,
			"top" : 0,
			"zindex" : 1,
			"rotation" : 0.0,
			"levitated" : false,
			"locked" : false,
			"hasTemplate" : false,
		},
		"properties" : {
			"showAbbreviatedNumbers" : true,
			"drilldownSection" : "default",
			"shapeHeight" : "90",
			"outsideFontSize" : "14",
			"domainObjectId" : "126",
			"section" : "scorecards",
			"background" : "none",
			"fontSize" : "13",
			"showLabel" : true,
			"fill" : "linear",
			"showTrend" : true,
			"type" : "shape",
			"shape" : "ellipse"
		},
		"connectors" : [ ]
	},
	"id" : 15001,
	"height" : 90,
	"width" : 150,
	"left" : 0,
	"top" : 0,
	"zindex" : 1,
	"rotation" : 0.0,
	"levitated" : false,
	"locked" : false,
	"hasTemplate" : false
}, {
	"widget" : {
		"type" : "shape",
		"data" : {
			"scorecards": {
				"126": {
					"id":126,
					"label":"Performance Bubble",
					"description":"",
					"type":"root",
					"useSourceNotes":false,
					"organizationId":100,
					"scores":{}
				}
			},
			"organizations": {
				"100": {
					"id":100,
					"label":"asdf",
					"view":true,
					"domainType":"organization"
				}
			}
		},
		"wob" : {
			"id" : 15002,
			"height" : 90,
			"width" : 150,
			"left" : 179,
			"top" : 0,
			"zindex" : 1,
			"rotation" : 0.0,
			"levitated" : false,
			"locked" : false,
			"hasTemplate" : false
		},
		"properties" : {
			"showAbbreviatedNumbers" : true,
			"shapeHeight" : "90",
			"drilldownSection" : "default",
			"outsideFontSize" : "14",
			"domainObjectId" : "126",
			"section" : "scorecards",
			"background" : "none",
			"fontSize" : "13",
			"showLabel" : true,
			"fill" : "linear",
			"type" : "shape",
			"showTrend" : true,
			"shape" : "ellipse"
		},
		"connectors" : [ ]
	},
	"id" : 15002,
	"height" : 90,
	"width" : 150,
	"left" : 179,
	"top" : 0,
	"zindex" : 1,
	"rotation" : 0.0,
	"levitated" : false,
	"locked" : false,
	"hasTemplate" : false
}, {
	"widget" : {
		"type" : "shape",
		"data" : {
			"scorecards": {
				"126": {
					"id":126,
					"label":"Performance Bubble",
					"description":"",
					"type":"root",
					"useSourceNotes":false,
					"organizationId":100,
					"scores":{}
				}
			},
			"organizations": {
				"100": {
					"id":100,
					"label":"asdf",
					"view":true,
					"domainType":"organization"
				}
			}
		},
		"wob" : {
			"id" : 15003,
			"height" : 90,
			"width" : 150,
			"left" : 358,
			"top" : 0,
			"zindex" : 1,
			"rotation" : 0.0,
			"levitated" : false,
			"locked" : false,
			"hasTemplate" : false
		},
		"properties" : {
			"showAbbreviatedNumbers" : true,
			"shapeHeight" : "90",
			"drilldownSection" : "default",
			"outsideFontSize" : "14",
			"domainObjectId" : "126",
			"section" : "scorecards",
			"background" : "none",
			"fontSize" : "13",
			"showLabel" : true,
			"fill" : "linear",
			"type" : "shape",
			"showTrend" : true,
			"shape" : "ellipse"
		},
		"connectors" : [ ]
	},
	"id" : 15003,
	"height" : 90,
	"width" : 150,
	"left" : 358,
	"top" : 0,
	"zindex" : 1,
	"rotation" : 0.0,
	"levitated" : false,
	"locked" : false,
	"hasTemplate" : false
}, {
	"widget" : {
		"type" : "shape",
		"data" : {
			"scorecards": {
				"126": {
					"id":126,
					"label":"Performance Bubble",
					"description":"",
					"type":"root",
					"useSourceNotes":false,
					"organizationId":100,
					"scores":{}
				}
			},
			"organizations": {
				"100": {
					"id":100,
					"label":"asdf",
					"view":true,
					"domainType":"organization"
				}
			}
		},
		"wob" : {
			"id" : 15004,
			"height" : 175,
			"width" : 150,
			"left" : 0,
			"top" : 477,
			"zindex" : 1,
			"rotation" : 0.0,
			"levitated" : false,
			"locked" : false,
			"hasTemplate" : false
		},
		"properties" : {
			"showAbbreviatedNumbers" : true,
			"shapeHeight" : "90",
			"drilldownSection" : "default",
			"outsideFontSize" : "14",
			"showWeight" : true,
			"showDescription" : true,
			"domainObjectId" : "126",
			"section" : "scorecards",
			"background" : "translucent",
			"showScore" : true,
			"fontSize" : "13",
			"showLabel" : true,
			"fill" : "linear",
			"shape" : "ellipse",
			"type" : "shape",
			"showTrend" : true
		},
		"connectors" : [ ]
	},
	"id" : 15004,
	"height" : 175,
	"width" : 150,
	"left" : 0,
	"top" : 477,
	"zindex" : 1,
	"rotation" : 0.0,
	"levitated" : false,
	"locked" : false,
	"hasTemplate" : false
}, {
	"widget" : {
		"type" : "shape",
		"data" : {
			"scorecards": {
				"126": {
					"id":126,
					"label":"Performance Bubble",
					"description":"",
					"type":"root",
					"useSourceNotes":false,
					"organizationId":100,
					"scores":{}
				}
			},
			"organizations": {
				"100": {
					"id":100,
					"label":"asdf",
					"view":true,
					"domainType":"organization"
				}
			}
		},
		"wob" : {
			"id" : 15005,
			"height" : 175,
			"width" : 150,
			"left" : 179,
			"top" : 477,
			"zindex" : 1,
			"rotation" : 0.0,
			"levitated" : false,
			"locked" : false,
			"hasTemplate" : false
		},
		"properties" : {
			"showAbbreviatedNumbers" : true,
			"shapeHeight" : "90",
			"drilldownSection" : "default",
			"outsideFontSize" : "14",
			"showWeight" : true,
			"showDescription" : true,
			"domainObjectId" : "126",
			"background" : "translucent",
			"section" : "scorecards",
			"showScore" : true,
			"fontSize" : "13",
			"showLabel" : true,
			"fill" : "linear",
			"shape" : "ellipse",
			"showTrend" : true,
			"type" : "shape"
		},
		"connectors" : [ ]
	},
	"id" : 15005,
	"height" : 175,
	"width" : 150,
	"left" : 179,
	"top" : 477,
	"zindex" : 1,
	"rotation" : 0.0,
	"levitated" : false,
	"locked" : false,
	"hasTemplate" : false
}, {
	"widget" : {
		"type" : "shape",
		"data" : {
			"scorecards": {
				"126": {
					"id":126,
					"label":"Performance Bubble",
					"description":"",
					"type":"root",
					"useSourceNotes":false,
					"organizationId":100,
					"scores":{}
				}
			},
			"organizations": {
				"100": {
					"id":100,
					"label":"asdf",
					"view":true,
					"domainType":"organization"
				}
			}
		},
		"wob" : {
			"id" : 15006,
			"height" : 175,
			"width" : 150,
			"left" : 358,
			"top" : 477,
			"zindex" : 1,
			"rotation" : 0.0,
			"levitated" : false,
			"locked" : false,
			"hasTemplate" : false
		},
		"properties" : {
			"showAbbreviatedNumbers" : true,
			"shapeHeight" : "90",
			"drilldownSection" : "default",
			"outsideFontSize" : "14",
			"showWeight" : true,
			"domainObjectId" : "126",
			"showDescription" : true,
			"background" : "translucent",
			"section" : "scorecards",
			"showScore" : true,
			"showLabel" : true,
			"fontSize" : "13",
			"fill" : "linear",
			"shape" : "ellipse",
			"type" : "shape",
			"showTrend" : true
		},
		"connectors" : [ ]
	},
	"id" : 15006,
	"height" : 175,
	"width" : 150,
	"left" : 358,
	"top" : 477,
	"zindex" : 1,
	"rotation" : 0.0,
	"levitated" : false,
	"locked" : false,
	"hasTemplate" : false
}, {
	"widget" : {
		"type" : "shape",
		"data" : {
			"scorecards": {
				"126": {
					"id":126,
					"label":"Performance Bubble",
					"description":"",
					"type":"root",
					"useSourceNotes":false,
					"organizationId":100,
					"scores":{}
				}
			},
			"organizations": {
				"100": {
					"id":100,
					"label":"asdf",
					"view":true,
					"domainType":"organization"
				}
			}
		},
		"wob" : {
			"id" : 15007,
			"height" : 88,
			"width" : 150,
			"left" : 0,
			"top" : 130,
			"zindex" : 1,
			"rotation" : 0.0,
			"levitated" : false,
			"locked" : false,
			"hasTemplate" : false
		},
		"properties" : {
			"showAbbreviatedNumbers" : true,
			"drilldownSection" : "default",
			"shapeHeight" : "60",
			"outsideFontSize" : "14",
			"domainObjectId" : "126",
			"showTrend" : true,
			"background" : "white",
			"section" : "scorecards",
			"showLabel" : true,
			"fill" : "linear",
			"fontSize" : "13",
			"shape" : "ellipse",
			"type" : "shape"
		},
		"connectors" : [ ]
	},
	"id" : 15007,
	"height" : 88,
	"width" : 150,
	"left" : 0,
	"top" : 130,
	"zindex" : 1,
	"rotation" : 0.0,
	"levitated" : false,
	"locked" : false,
	"hasTemplate" : false
}, {
	"widget" : {
		"type" : "shape",
		"data" : {
			"scorecards": {
				"126": {
					"id":126,
					"label":"Performance Bubble",
					"description":"",
					"type":"root",
					"useSourceNotes":false,
					"organizationId":100,
					"scores":{}
				}
			},
			"organizations": {
				"100": {
					"id":100,
					"label":"asdf",
					"view":true,
					"domainType":"organization"
				}
			}
		},
		"wob" : {
			"id" : 15008,
			"height" : 88,
			"width" : 150,
			"left" : 179,
			"top" : 130,
			"zindex" : 1,
			"rotation" : 0.0,
			"levitated" : false,
			"locked" : false,
			"hasTemplate" : false
		},
		"properties" : {
			"showAbbreviatedNumbers" : true,
			"drilldownSection" : "default",
			"shapeHeight" : "60",
			"outsideFontSize" : "14",
			"domainObjectId" : "126",
			"showTrend" : true,
			"background" : "white",
			"section" : "scorecards",
			"shape" : "ellipse",
			"showLabel" : true,
			"fill" : "linear",
			"fontSize" : "13",
			"type" : "shape"
		},
		"connectors" : [ ]
	},
	"id" : 15008,
	"height" : 88,
	"width" : 150,
	"left" : 179,
	"top" : 130,
	"zindex" : 1,
	"rotation" : 0.0,
	"levitated" : false,
	"locked" : false,
	"hasTemplate" : false
}, {
	"widget" : {
		"type" : "shape",
		"data" : {
			"scorecards": {
				"126": {
					"id":126,
					"label":"Performance Bubble",
					"description":"",
					"type":"root",
					"useSourceNotes":false,
					"organizationId":100,
					"scores":{}
				}
			},
			"organizations": {
				"100": {
					"id":100,
					"label":"asdf",
					"view":true,
					"domainType":"organization"
				}
			}
		},
		"wob" : {
			"id" : 15009,
			"height" : 88,
			"width" : 150,
			"left" : 358,
			"top" : 130,
			"zindex" : 1,
			"rotation" : 0.0,
			"levitated" : false,
			"locked" : false,
			"hasTemplate" : false
		},
		"properties" : {
			"showAbbreviatedNumbers" : true,
			"drilldownSection" : "default",
			"shapeHeight" : "60",
			"outsideFontSize" : "14",
			"domainObjectId" : "126",
			"showTrend" : true,
			"background" : "white",
			"section" : "scorecards",
			"shape" : "ellipse",
			"showLabel" : true,
			"fill" : "linear",
			"type" : "shape",
			"fontSize" : "13"
		},
		"connectors" : [ ]
	},
	"id" : 15009,
	"height" : 88,
	"width" : 150,
	"left" : 358,
	"top" : 130,
	"zindex" : 1,
	"rotation" : 0.0,
	"levitated" : false,
	"locked" : false,
	"hasTemplate" : false
}, {
	"widget" : {
		"type" : "shape",
		"data" : {
			"scorecards": {
				"126": {
					"id":126,
					"label":"Performance Bubble",
					"description":"",
					"type":"root",
					"useSourceNotes":false,
					"organizationId":100,
					"scores":{}
				}
			},
			"organizations": {
				"100": {
					"id":100,
					"label":"asdf",
					"view":true,
					"domainType":"organization"
				}
			}
		},
		"wob" : {
			"id" : 15010,
			"height" : 179,
			"width" : 150,
			"left" : 0,
			"top" : 258,
			"zindex" : 1,
			"rotation" : 0.0,
			"levitated" : false,
			"locked" : false,
			"hasTemplate" : false
		},
		"properties" : {
			"showAbbreviatedNumbers" : true,
			"drilldownSection" : "default",
			"shapeHeight" : "60",
			"outsideFontSize" : "14",
			"showWeight" : true,
			"domainObjectId" : "126",
			"showTrend" : true,
			"showDescription" : true,
			"background" : "white",
			"fill" : "linear",
			"section" : "scorecards",
			"shape" : "ellipse",
			"showScore" : true,
			"showLabel" : true,
			"type" : "shape",
			"fontSize" : "13"
		},
		"connectors" : [ ]
	},
	"id" : 15010,
	"height" : 179,
	"width" : 150,
	"left" : 0,
	"top" : 258,
	"zindex" : 1,
	"rotation" : 0.0,
	"levitated" : false,
	"locked" : false,
	"hasTemplate" : false
}, {
	"widget" : {
		"type" : "shape",
		"data" : {
			"scorecards": {
				"126": {
					"id":126,
					"label":"Performance Bubble",
					"description":"",
					"type":"root",
					"useSourceNotes":false,
					"organizationId":100,
					"scores":{}
				}
			},
			"organizations": {
				"100": {
					"id":100,
					"label":"asdf",
					"view":true,
					"domainType":"organization"
				}
			}
		},
		"wob" : {
			"id" : 15011,
			"height" : 179,
			"width" : 150,
			"left" : 179,
			"top" : 258,
			"zindex" : 1,
			"rotation" : 0.0,
			"levitated" : false,
			"locked" : false,
			"hasTemplate" : false
		},
		"properties" : {
			"showAbbreviatedNumbers" : true,
			"drilldownSection" : "default",
			"shapeHeight" : "60",
			"outsideFontSize" : "14",
			"showWeight" : true,
			"domainObjectId" : "126",
			"showTrend" : true,
			"background" : "white",
			"showDescription" : true,
			"fill" : "linear",
			"section" : "scorecards",
			"shape" : "ellipse",
			"showScore" : true,
			"showLabel" : true,
			"type" : "shape",
			"fontSize" : "13"
		},
		"connectors" : [ ]
	},
	"id" : 15011,
	"height" : 179,
	"width" : 150,
	"left" : 179,
	"top" : 258,
	"zindex" : 1,
	"rotation" : 0.0,
	"levitated" : false,
	"locked" : false,
	"hasTemplate" : false
}, {
	"widget" : {
		"type" : "shape",
		"data" : {
			"scorecards": {
				"126": {
					"id":126,
					"label":"Performance Bubble",
					"description":"",
					"type":"root",
					"useSourceNotes":false,
					"organizationId":100,
					"scores":{}
				}
			},
			"organizations": {
				"100": {
					"id":100,
					"label":"asdf",
					"view":true,
					"domainType":"organization"
				}
			}
		},
		"wob" : {
			"id" : 15012,
			"height" : 179,
			"width" : 150,
			"left" : 358,
			"top" : 258,
			"zindex" : 1,
			"rotation" : 0.0,
			"levitated" : false,
			"locked" : false,
			"hasTemplate" : false
		},
		"properties" : {
			"showAbbreviatedNumbers" : true,
			"drilldownSection" : "default",
			"shapeHeight" : "60",
			"showWeight" : true,
			"outsideFontSize" : "14",
			"domainObjectId" : "126",
			"showDescription" : true,
			"showTrend" : true,
			"background" : "white",
			"fill" : "linear",
			"section" : "scorecards",
			"shape" : "ellipse",
			"showScore" : true,
			"showLabel" : true,
			"type" : "shape",
			"fontSize" : "13"
		},
		"connectors" : [ ]
	},
	"id" : 15012,
	"height" : 179,
	"width" : 150,
	"left" : 358,
	"top" : 258,
	"zindex" : 1,
	"rotation" : 0.0,
	"levitated" : false,
	"locked" : false,
	"hasTemplate" : false
}]
